/* eslint-disable indent */
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { SUBDOMAIN_NOT_DEPLOY, SUBDOMAIN_DEPLOYED } from '_utils/constant'
import { getUserInfo } from '_utils/localData'

const getRoleText = (isHost, isAdmin) => {
  if (isAdmin === 1) return 'Admin'
  if (isHost === 1) return 'Host'
  return 'Member'
}

const getInitials = (name) => {
  if (!name) return 'G'
  const words = name.trim().split(' ')
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase()
  }
  return name.slice(0, 2).toUpperCase()
}

const AVATAR_COLORS = ['#E8971A', '#009A97', '#9B59B6', '#E74C3C', '#3498DB']

const GroupItem = ({
  groupInfo,
  isJoin = false,
  requested,
  setGroupSelected,
  toggleModal,
  disabled = false,
  index = 0,
}) => {
  const { totalMembers, totalEvents, photoUrl, id, name, gid, isHost, isAdmin } = groupInfo

  const userInfo = getUserInfo()
  const { domainFeatures = [] } = userInfo || {}
  const domainIncluded = domainFeatures.find((g) => g.groupId === gid) || {}

  const handleJoinGroup = (e) => {
    e?.stopPropagation?.()
    if (setGroupSelected && toggleModal) {
      setGroupSelected(groupInfo)
      toggleModal()
    }
  }

  const roleText = getRoleText(isHost, isAdmin)
  const avatarBg = AVATAR_COLORS[index % AVATAR_COLORS.length]
  const photoSrc = photoUrl?.url || (typeof photoUrl === 'string' && photoUrl ? photoUrl : null)

  return (
    <Link to={`/group/list-events?groupId=${id}`} className='group-list-item'>
      <div className={`group-avatar-wrap ${disabled ? 'disabled' : ''}`}>
        <div className='group-avatar' style={{ background: avatarBg }}>
          {photoSrc ? (
            <img src={photoSrc} alt={name} />
          ) : (
            <span>{getInitials(name)}</span>
          )}
        </div>
      </div>
      <div className={`group-info ${disabled ? 'disabled' : ''}`}>
        <div className='group-name'>{name}</div>
        <div className='group-meta'>
          {totalMembers || 0} Members &nbsp;
          <span>
            {isJoin ? `${totalEvents || 0} Organized Deals` : `${totalEvents || 0} Organized Events`}
          </span>
        </div>

        {domainIncluded &&
        domainIncluded.domainStatus &&
        domainIncluded.domainStatus === SUBDOMAIN_NOT_DEPLOY ? (
          <div style={{ fontSize: '11px', marginTop: '2px' }}>
            <span style={{ color: '#e0a800' }}>{domainIncluded.domainName}</span>
          </div>
        ) : null}

        {domainIncluded &&
        domainIncluded.domainStatus &&
        domainIncluded.domainStatus === SUBDOMAIN_DEPLOYED ? (
          <div style={{ fontSize: '11px', marginTop: '2px' }}>
            <a
              href={`https://${domainIncluded.domainName}`}
              target='_blank'
              style={{ color: '#009A97' }}
              rel='noreferrer'
            >
              {domainIncluded.domainName}
            </a>
          </div>
        ) : null}
      </div>
      {isJoin ? (
        <div className='group-list__btn'>
          <button
            className={`group-drop-join ${requested ? 'group-drop-req' : ''}`}
            disabled={requested}
            onClick={handleJoinGroup}
          >
            {requested ? 'REQUESTED' : 'JOIN'}
          </button>
        </div>
      ) : (
        <div className='group-role'>{roleText}</div>
      )}
    </Link>
  )
}

GroupItem.propTypes = {
  groupInfo: PropTypes.object.isRequired,
  isJoin: PropTypes.bool,
  requested: PropTypes.bool,
  setGroupSelected: PropTypes.func,
  toggleModal: PropTypes.func,
  disabled: PropTypes.bool,
  index: PropTypes.number,
}

export default GroupItem
